module.exports = __webpack_public_path__ + "img/H18.4526c1c9.jpg";